var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-message-container"},[_vm._t("icon"),_vm._t("title"),_vm._t("default"),(_vm.$slots['code'])?_vm._t("code"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }